import React from "react";

const Membercard = ({ image, name, club }) => {
  return (
    <div className="h-48 w-40 ">
      <img src={image} alt="" className="h-36 w-36 rounded-full object-cover" />
      <div className="text-center mt-2">
        <h2 className="text-lg font-semibold">{name}</h2>
        <p className="text-sm text-gray-400">{club}</p>
      </div>
    </div>
  );
};

export default Membercard;
